import styled from 'styled-components'

import DonginMarketIntroduction from '~/features/event-info/components/DonginMarketIntroduction'
import DonginMarketImageSrc from '~/shared/assets/images/donin-market.png'
import theme from '~/shared/styles/theme'

function DonginMarket() {
  return (
    <Wrapper>
      <DonginMarketInfo>
        <TitleWrapper>
          <Title>동인 마켓</Title>
          <DonginMarketImageMobile src={DonginMarketImageSrc} />
        </TitleWrapper>
        <Desc>
          아마추어 & 프로 작가들이 직접 만든 오리지널 상품 및 기성 IP의 2차 창작
          상품을 판매하는 플리 마켓 (Flea Market).
          <br />
          <br />
          참가 부스 토, 일 양일 합계 1,500부스 규모 이상 전회(2회) 기준 1,183
          부스 규모 참여
        </Desc>
        <DonginMarketIntroduction />
      </DonginMarketInfo>
      <DonginMarketImage src={DonginMarketImageSrc} />
    </Wrapper>
  )
}

export default DonginMarket

const Wrapper = styled.div`
  display: flex;
  height: auto;

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 36px;
    padding-top: 72px;
  }
`

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const Title = styled.h2`
  z-index: 1; /* 이미지 위에 텍스트가 오도록 설정 */
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 500;

  @media ${theme.device.medium} {
    font-size: 32px;
  }
`

const Desc = styled.p`
  font-size: 24px;

  @media ${theme.device.medium} {
    font-size: 24px;
  }
`

const DonginMarketInfo = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 36px;
`

const DonginMarketImage = styled.img`
  position: relative;
  right: -100px;
  flex: 1;

  @media ${theme.device.medium} {
    display: none;
  }
`

const DonginMarketImageMobile = styled.img`
  display: none;

  @media ${theme.device.medium} {
    position: absolute;
    z-index: -100;
    top: 10;
    left: 70%;
    transform: translateX(-50%);

    display: block;

    width: 100%;
    height: auto;
  }
`
